import React from 'react'
import ReviewForm from './ReviewForm'
import Reviews from './Reviews'
import Image from 'next/image'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import Link from 'next/link'
import { useContextElement } from '@/context/Context'
import Styles from '@/components/blogs/BlogDetails.module.css'

export default function Article({ data }) {
  return (
    <section className="blog-page blog-single container">
      <div className="mw-930">
        <h2 className="page-title">{data.ArticleTitle}</h2>
        <div className="blog-single__item-meta">
          <span className="blog-single__item-meta__date">
            更新日期 : {data.PublishedDateFormatted}
          </span>
          <span className="blog-single__item-meta__date">
            閱讀次數 : {data.ViewCount}
          </span>
        </div>
      </div>

      <div className="row d-flex justify-content-center">
        <div className="col-12 col-md-4 mb-3 md-mb-0">
          <div
            style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              overflow: 'hidden',
            }}
          >
            <img
              loading="lazy"
              src={data.PicturePath}
              style={{
                width: '100%',
                height: 'auto',
              }}
            />
          </div>
        </div>

        <div className=" col-12 col-md-4">
          <div className="blog-list__item-title">{data.ArticleTitle}</div>
          <div className="blog-list__item-content">
            <p>{data.Description}</p>
          </div>
          <div className="blog-list__item-meta">
            <span className="blog-list__item-meta__date">
              更新日期: {data.PublishedDateFormatted}
            </span>
          </div>
        </div>
      </div>

      {data.Content && data.Content != '' && (
        <>
          <div
            className={`${Styles.articleContent} blog-single__item-content`}
            dangerouslySetInnerHTML={{ __html: data.Content }}
          ></div>
        </>
      )}
    </section>
  )
}
